import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ContentLoaderComponent} from './content-loader.component';

@NgModule({
  imports: [
    CommonModule
  ],
  exports: [
    ContentLoaderComponent
  ],
  declarations: [ContentLoaderComponent]
})
export class ContentLoaderModule { }
